/**
 * Adapt users to options
 * Sort alphabetically by label
 * @param {Array} users
 * @returns {Array}
 */
const adaptUsersToOptions = (users = []) =>
  users
    .slice()
    .map(({ userId, name, lastName, email, phone, isResponsible }) => ({
      id: userId,
      label: `${name || ''} ${lastName || ''} (${email ? `${email} - ` : ''}${phone || ''})`,
      isResponsible: isResponsible
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

export default adaptUsersToOptions;
